const utils = require( './utilities.js' );
const ui = require( './ui.js' );

function cacheSelectors() {
    let $sel = {
        'form': {
            '$sendEmail': $('.form--send-email'),
            '$resetPassword': $('.form--reset-password'),
        },
        '$insertEmail': $('.insert-email')
    };
    $sel.input = {
        '$emailFields': $sel.form.$sendEmail.find('.input'),
        '$resetPasswordFields': $sel.form.$resetPassword.find('.input'),
        '$passwordToggle': $sel.form.$resetPassword.find('.password--toggle'),
    };
    $sel.msg = {
        '$sendEmail': $sel.form.$sendEmail.find('.form__message'),
        '$resetPassword': $sel.form.$resetPassword.find('.form__message'),
    };
    $sel.btn = {
        '$sendEmail': $sel.form.$sendEmail.find('.btn'),
        '$resetPassword': $sel.form.$resetPassword.find('.btn'),
    };
    return $sel;
}

function init() {
    const $sel = cacheSelectors();

    $sel.form.$sendEmail.on('keyup', utils.debounce((e) => {
        utils.form.handleSubmit(e, sendPasswordEmail);
    }));
    $sel.btn.$sendEmail.on('click', utils.debounce(sendPasswordEmail));

    function sendPasswordEmail() {
        let data = {};
        if(utils.form.prepareRequest($sel.input.$emailFields, data) && !utils.form.isProcessing) {
            utils.form.isProcessing = true;
            ui.loader.show();
            const post = $.ajax({
                method: 'POST',
                url: '/wp-json/alterwood/v1/send-password-email', 
                data: data,
            });
            post.always((res) => {
                console.log(res);
                if (res.status === 'error') {
                    $sel.input.$emailFields.filter(res.input).addClass('error').after('<p class="input__message error">' + res.message + '</p>');
    
                } else {
                    $sel.$insertEmail.text(data.email);
                    $sel.form.$sendEmail.find('.form--before, .form--after').addClass('active');
                }
                utils.form.isProcessing = false;
                ui.loader.hide();
            });
        }
    }

    $sel.form.$resetPassword.on('keyup', utils.debounce((e) => {
        utils.form.handleSubmit(e, resetPassword);
    }));
    $sel.btn.$resetPassword.on('click', utils.debounce(resetPassword));

    $sel.input.$resetPasswordFields.on('focusin', function() {
        $(this).removeClass('error');
    }).on('focusout', function(e) {
        utils.form.validateInput(e, $(this), $sel.input.$resetPasswordFields);
    });

    $sel.input.$resetPasswordFields.filter('#password').on('keyup', (e, el) => {
        utils.form.validatePassword(e, el);
    });

    $sel.input.$passwordToggle.on('click', () => {
        utils.form.togglePassword($sel.input.$resetPasswordFields);
    });

    function resetPassword() {
        let data = {};
        if (utils.form.prepareRequest($sel.input.$resetPasswordFields, data) && !utils.form.isProcessing) {
            utils.form.isProcessing = true;
            ui.loader.show();
            const post = $.ajax({
                method: 'POST',
                url: '/wp-json/alterwood/v1/reset-password', 
                data: data,
            });
            post.always((res) => {
                console.log(res);
                if (res.status === 'error') {
                    $sel.msg.$sendEmail.text(res.message);
                } else {
                    window.location.href = res.redirect;
                }
                utils.form.isProcessing = false;
                ui.loader.hide();
            });
        }
    }
}

/**
 * Public API
 *
 * @type {Object}
 */
 module.exports = {
	init: init
};


// WEBPACK FOOTER //
// ./scripts/components/reset-pass.js